import { analyticsLocalStorage, uploadEntry } from '.';

const uploadAllEntries = () => {
  const now = Date.now();

  const isVuoSessionExpired = sessionStorage.getItem('isVuoSessionExpired');
  if (isVuoSessionExpired === 'true') return Promise.resolve();

  // check if offline
  if (window.Offline && window.Offline.state === 'down') {
    return Promise.resolve();
  }

  // get local storage entries and merge same type packages
  const referenceKeys = JSON.parse(
    localStorage.getItem('vuoAnalyticsReferenceKeys') || '{}'
  );
  const keys = analyticsLocalStorage.getKeys();

  const packetsToSendByCourseId = {};
  const keysToProcess = [];
  for (const key of keys) {
    if (referenceKeys[key] && now - referenceKeys[key] < 60000) continue;

    let value = localStorage.getItem(key);

    const item = JSON.parse(Base64.decode(value));
    const { type, courseId } = item;

    if (!packetsToSendByCourseId[courseId]) {
      packetsToSendByCourseId[courseId] = {
        analytics: { data: [], keys: [] },
        courseAccess: { data: [], keys: [] },
        search: { data: [], keys: [] }
      };
    }

    if (type === 'video') {
      // filter any NaN values from viewTimes
      const blockIds = Object.keys(item.data);

      blockIds.forEach((blockId) => {
        const { viewTimes } = item.data[blockId];
        delete viewTimes.NaN;

        item.data[blockId].viewTimes = viewTimes;
      });

      packetsToSendByCourseId[courseId].analytics.data.push(item);
      packetsToSendByCourseId[courseId].analytics.keys.push(key);
    } else if (type === 'blockActivity') {
      packetsToSendByCourseId[courseId].analytics.data.push(item);
      packetsToSendByCourseId[courseId].analytics.keys.push(key);
    } else if (type === 'courseAccess') {
      packetsToSendByCourseId[courseId].courseAccess.data.push(item);
      packetsToSendByCourseId[courseId].courseAccess.keys.push(key);
    } else if (type === 'search') {
      packetsToSendByCourseId[courseId].search.data.push(item);
      packetsToSendByCourseId[courseId].search.keys.push(key);
    }

    keysToProcess.push(key);
  }

  // update reference keys in local storage
  localStorage.setItem(
    'vuoAnalyticsReferenceKeys',
    JSON.stringify(
      keysToProcess.reduce((keys, key) => {
        keys[key] = now;
        return keys;
      }, referenceKeys)
    )
  );

  // organize and send packages by course id and type
  const packets = Object.keys(packetsToSendByCourseId).reduce(
    (all, courseId) => {
      const { analytics, courseAccess, search } =
        packetsToSendByCourseId[courseId];

      if (analytics.keys.length) {
        all.push({ courseId, type: 'analytics', packet: analytics });
      }
      if (courseAccess.keys.length) {
        all.push({ courseId, type: 'course-access', packet: courseAccess });
      }
      if (search.keys.length) {
        all.push({ courseId, type: 'search', packet: search });
      }
      return all;
    },
    []
  );

  return Promise.all(packets.map((data) => uploadEntry(data)));
};

export default uploadAllEntries;
